(function () {
  'use strict';

  angular.module('ringbaPortal.services').factory('callTrackingTagService', CallTrackingTagService);

  function CallTrackingTagService(
    _,
    $q,
    $http,
    accountsService,
    numberPoolService,
    ngAuthSettings,
    promiseCacheService
  ) {
    const serviceBaseUri = ngAuthSettings.apiServiceBaseUri;
    const service = {
      createCallTrackingTag: createCallTrackingTag,
      getCallTrackingTag: getCallTrackingTag,
      updateCallTrackingTag: updateCallTrackingTag,
      deleteCallTrackingTag: deleteCallTrackingTag,
      getCampaignCallTrackingTags: getCampaignCallTrackingTags,
      getCallTrackingTagsLinkedPools: getCallTrackingTagsLinkedPools
    };
    return service;

    function getCampaignCallTrackingTags(accountId, campaign) {
      if (campaign && campaign.affiliateNumbers) {
        const promises = [],
          tags = [];

        _.forEach(campaign.affiliateNumbers, function (number) {
          if (number.jsTagId) {
            promises.push(getCallTrackingTag(accountId, campaign.id, number.affiliate.id, number.id)
              .then(function (tag) {
                tag.number = number;
                if (tag.previousNumber && tag.previousNumber.e164Number) {
                  tag.e164ExistingNumber = tag.previousNumber.e164Number;
                }
                tags.push(tag);
                return;
              })
              .catch(function() {
                // if no tag is generated for a given number we'll get a 404
              })
            );
          }
        });
        return $q.all(promises).then(function () {
          return tags;
        });
      }
      return $q.when([]);
    }

    function getCallTrackingTagsLinkedPools(accountId, campaign) {
      const tags = campaign.jsTags;
      const promises = [];
      if (campaign && tags && accountsService.isAdmin()) {
        _.forEach(tags, function (jsTag) {
          if (jsTag.numberPoolId) {
            promises.push(numberPoolService.getNumberPool(accountId, jsTag.numberPoolId, true).then(function (response) {
              jsTag.numberPool = response && response.data ? response.data.numberPool : undefined;

              if (jsTag.numberPool) {
                jsTag.numberPool.jsTagName = jsTag.name;
              }
            }));
          }
        });
        return $q.all(promises).then(function () {
          return tags;
        });
      }
      return $q.when(tags);
    }

    function createCallTrackingTag(accountId, campaignId, affiliateId, numberId, callTrackingTag) {
      const url = _serviceBaseUrl(accountId, campaignId, affiliateId, numberId);
      return $http.post(url, callTrackingTag);
    }

    function updateCallTrackingTag(accountId, campaignId, affiliateId, numberId, callTrackingTagId, name, e164ExistingNumber, numberPoolId, hasNumberPool) {
      const url = _serviceBaseUrl(accountId, campaignId, affiliateId, numberId, callTrackingTagId);
      return $http.patch(url, {
        name: name,
        e164ExistingNumber: e164ExistingNumber,
        numberPoolId: numberPoolId,
        hasNumberPool: hasNumberPool
      });
    }

    function getCallTrackingTag(accountId, campaignId, affiliateId, numberId) {
      const url = _serviceBaseUrl(accountId, campaignId, affiliateId, numberId);
      let tag;
      return promiseCacheService.getCallWithCachedPromise(url, url, 5).then(function (response) {
        tag = response.data.tag;
        if (tag.numberPoolId && accountsService.isAdmin()) {
          return numberPoolService.getNumberPool(accountId, tag.numberPoolId, true);
        }
        return;
      }).then(function(response) {
        tag.numberPool = response && response.data ? response.data.numberPool : undefined;

        if (tag.numberPool) {
          tag.numberPool.jsTagName = tag.name;
        }
        return tag;
      });
    }

    function deleteCallTrackingTag(accountId, campaignId, affiliateId, numberId) {
      const url = _serviceBaseUrl(accountId, campaignId, affiliateId, numberId);
      return $http.delete(url);
    }

    function _serviceBaseUrl(accountId, campaignId, affiliateId, numberId, jsTagId) {
      let url = serviceBaseUri + accountId + '/campaigns/' + campaignId + '/affiliates/' + affiliateId + '/numbers/' + numberId + '/JsTag';
      if (jsTagId) {
        url += '/' + jsTagId;
      }
      return url;
    }
  }
})();
